import { default as Region } from './Region';

export { Region };



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/Region/components/index.js